'use client';

import { DisclosureTooltip } from '@ria-client/tw-shared-ui';
import { useEffect, useMemo } from 'react';
import { CITATION_LIST_ID } from './constants';
import type { ICitation } from './context';
import { useCitationContext } from './context';

export interface CitationProps {
  props: ICitation;
}

export function Citation({ props }: CitationProps) {
  const { registerCitation, unregisterCitation, scrollToCitationList } = useCitationContext();
  const citation = useMemo(() => registerCitation(props), [props, registerCitation]);
  const { citationNumber, publication, url, title, accessDateFormatted, showInline, id } = citation;

  useEffect(() => {
    return () => {
      unregisterCitation(citation);
    };
  }, [citation, unregisterCitation]);

  if (!showInline) return null;

  // Legacy Citation composes DisclosureTooltip (click-away + Escape dismiss via Popover),
  // using the render-prop trigger form so the <sup> ref button toggles it.
  // Body link is a plain <a>: tooltip content remounts per open, so ContentLink would re-fire
  // Link Viewed each time. The citation list tracks the same URL.
  return (
    <DisclosureTooltip
      trigger={toggle => (
        <button
          className="cursor-pointer bg-transparent p-0 text-inherit underline"
          id={`citation-ref-${id}`}
          onClick={toggle}
          type="button"
        >
          <sup>[{citationNumber}]</sup>
        </button>
      )}
    >
      <span className="flex flex-col gap-2">
        <span>
          {publication}.{' '}
          <a href={url} target="_blank">
            {title}
          </a>
          .<span className="block">{accessDateFormatted}</span>
        </span>
        <a
          href={`#${CITATION_LIST_ID}`}
          onClick={event => {
            event.preventDefault();
            scrollToCitationList();
          }}
        >
          View all sources
        </a>
      </span>
    </DisclosureTooltip>
  );
}
